import React from 'react';

const FlexMessageRenderer = ({ flexContent }) => {
    if (!flexContent || flexContent.type !== 'bubble') return null;

    const renderBox = (box, index) => {
        if (!box || box.type !== 'box') return null;

        const boxStyle = {
            display: 'flex',
            flexDirection: box.layout === 'vertical' ? 'column' : 'row',
            alignItems: box.layout === 'baseline' ? 'baseline' : 'stretch',
            backgroundColor: box.backgroundColor || 'transparent',
            borderRadius: box.cornerRadius === 'md' ? '8px' : undefined,
            padding: box.paddingAll === 'md' ? '12px' : box.paddingAll === 'sm' ? '8px' : undefined,
            margin: box.margin === 'lg' ? '16px 0' : box.margin === 'md' ? '12px 0' : box.margin === 'xs' ? '4px 0' : undefined,
            gap: box.spacing === 'xs' ? '4px' : box.spacing === 'sm' ? '8px' : box.spacing === 'md' ? '12px' : undefined,
        };

        return (
            <div key={index} style={boxStyle}>
                {box.contents?.map((content, idx) => renderContent(content, idx))}
            </div>
        );
    };

    const renderText = (text, index) => {
        if (!text || text.type !== 'text') return null;

        const textStyle = {
            fontSize: text.size === 'xs' ? '10px' : text.size === 'sm' ? '12px' : text.size === 'md' ? '14px' : text.size === 'lg' ? '16px' : text.size === 'xl' ? '18px' : '14px',
            color: text.color || '#333333',
            fontWeight: text.weight === 'bold' ? 'bold' : 'normal',
            textAlign: text.align || 'left',
            flex: text.flex || undefined,
            whiteSpace: text.wrap ? 'pre-wrap' : 'normal',
            wordBreak: text.wrap ? 'break-word' : 'normal',
        };

        return (
            <div key={index} style={textStyle}>
                {text.text}
            </div>
        );
    };

    const renderSeparator = (separator, index) => {
        if (!separator || separator.type !== 'separator') return null;

        const separatorStyle = {
            height: '1px',
            backgroundColor: '#E0E0E0',
            margin: separator.margin === 'lg' ? '16px 0' : separator.margin === 'md' ? '12px 0' : separator.margin === 'sm' ? '8px 0' : '8px 0',
        };

        return <div key={index} style={separatorStyle} />;
    };

    const renderContent = (content, index) => {
        if (!content) return null;

        switch (content.type) {
            case 'box':
                return renderBox(content, index);
            case 'text':
                return renderText(content, index);
            case 'separator':
                return renderSeparator(content, index);
            default:
                return null;
        }
    };

    const bubbleStyle = {
        backgroundColor: flexContent.styles?.body?.backgroundColor || '#FFFFFF',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxWidth: '100%',
    };

    const bodyStyle = {
        padding: flexContent.body?.paddingAll === 'md' ? '12px' : '16px',
    };

    return (
        <div style={bubbleStyle}>
            {flexContent.body && (
                <div style={bodyStyle}>
                    {flexContent.body.contents?.map((content, index) => renderContent(content, index))}
                </div>
            )}
        </div>
    );
};

export default FlexMessageRenderer;
